import i18next from 'i18next';

i18next.addResources('en', 'FermentationInformationModal', {
  fermentationOperator: 'Fermentation Operator',
  fermentedBy: 'Fermented By',
  averageHours: 'Average hours of Fermentation'
});
